<template>
  <div class="orderImmediately">
    <div style="display: flex; margin-top: 1rem">
      <div style="flex: 2; font-size: 1.5rem">提交订单</div>
      <div class="flexCenter">
        <div style="color: #015603">提交订单</div>
        <div>》</div>
        <div>订单审核</div>
        <div>》</div>
        <div>付款并投产</div>
      </div>
    </div>
    <div style="color: #999; font-size: 0.8rem; margin: 0.5rem 0 0 0.5rem">
      备注：您的订单预计生产完成时间带订单审核完才能给出
    </div>
    <div class="steps">
      <div>
        <div
          style="font-size: 3rem; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-dingdan"
        >
          <span style="font-size: 0.8rem; color: #fff">提交订单</span>
        </div>
      </div>
      <div>
        <div
          style="font-size: 50px; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-arrow-right-full"
        ></div>
      </div>
      <div>
        <div
          style="font-size: 3rem; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-shenhe"
        >
          <span style="font-size: 0.8rem; color: #fff">审核订单</span>
        </div>
      </div>
      <div>
        <div
          style="font-size: 50px; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-arrow-right-full"
        />
      </div>
      <div>
        <div
          style="font-size: 3rem; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-zhifu"
        >
          <span style="font-size: 0.8rem; color: #fff">支付订单</span>
        </div>
      </div>
      <div>
        <div
          style="font-size: 50px; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-arrow-right-full"
        />
      </div>
      <div
        style="font-size: 3rem; color: rgba(255, 255, 255, 0.3)"
        class="iconfont icon-shengchan"
      >
        <span style="font-size: 0.8rem; color: #fff">生产订单</span>
      </div>
      <div>
        <div
          style="font-size: 50px; color: rgba(255, 255, 255, 0.3)"
          class="iconfont icon-arrow-right-full"
        />
      </div>
      <div
        style="font-size: 3rem; color: rgba(255, 255, 255, 0.3)"
        class="iconfont icon-shippingdelivery"
      >
        <span style="font-size: 0.8rem; color: #fff">订单完成</span>
      </div>
    </div>
    <div class="address">
      <p>选择发货信息</p>
      <hr />
      <p
        @click="clickIsShow"
        style="color: #12a182; text-align: right; font-size: 0.8rem"
      >
        添加地址
      </p>
      <div :class="PackUp == false ? 'sorcll' : ''">
        <div
          @click="choose(index, item)"
          v-for="(item, index) in addres"
          :key="index"
          class="addresFlex"
        >
          <p :class="indexCoose == index ? 'box' : 'chooseNot'">
            {{ item.Name }}
          </p>
          <div>
            {{ item.Province }}-{{ item.City }}-{{ item.Area }} -{{
              item.Detail
            }}
          </div>
          <div
            @click="editor(item)"
            :style="indexCoose == index ? 'color:#f00' : ''"
          >编辑</div>
        </div>
      </div>
      <p style="color: #12a182; font-size: 0.8rem" v-if="PackUp" @click="more">
        更多地址>>
      </p>
    </div>
    <div class="orderInformation">
      <p>查看并确认您的订单包:</p>
      <div class="fromHeader">
        <div></div>
        <div>订单</div>
        <div>数量</div>
        <div>文件上传</div>
        <div>价格</div>
      </div>

      <div class="from">
        <div>
          <img src="../../assets/imges/prologo1.png" alt="" />
        </div>
        <div>{{ orderNumber }}</div>
        <div>{{ getnumberOf }}</div>
        <div>
          <el-upload
            v-if="orderType == 2"
            class="upload-demo"
            action="http://182.254.196.172:8026/api/upload/uploadFileOrder"
            :on-change="handleFileChange"
            :on-success="succes"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :limit="1"
          >
            <el-button v-if="btnIsShow" type="success" plain
              >点击上传</el-button
            >
          </el-upload>
          <div v-if="orderType == 3">
            {{ orderFrom.Model }}
          </div>
        </div>
        <div v-if="orderType == 2">{{ orderFromArray[2].Ord_Price }}</div>
        <div v-if="orderType == 3">{{ ordp.Ord_Price }}</div>
        <!-- <div v-if="orderType==3">{{ orderFromArray[2].Ord_Price }}</div> -->
      </div>
    </div>

    <!-- 工程联系人 -->
    <div style="margin-top: 1rem">
      <p style="font-weight: 600; font-size: 1rem">工程联系人</p>
      <div class="flexBox">
        <div>工程联系人:</div>
        <div>
          <el-input v-model="person.EContact" />
        </div>
      </div>
      <div class="flexBox">
        <div>工程联系电话:</div>
        <div><el-input v-model="person.EContact_Phone" /></div>
      </div>
      <div class="flexBox">
        <div>工程联系邮箱:</div>
        <div><el-input v-model="person.EContact_Email" /></div>
      </div>
    </div>
    <!-- 订单价格信息 -->
    <div class="orderBottom">
      <div v-if="orderType == 2">
        产品费:￥{{ orderFromArray[2].Ord_Price }}
      </div>
      <div v-if="orderType == 2">
        板材费用:￥{{ orderFromArray[2].Ord_Price + CourierFees }}
      </div>
      <div v-if="orderType == 3">板材费用:￥{{ ordp.Ord_Price }}</div>
    </div>
    <div style="text-align: right; font-size: 1rem; margin-top: 0.5rem">
      总合计:
      <span style="font-size: 1.3rem; color: #83cbac" v-if="orderType == 2"
        >￥{{ orderFromArray[2].Ord_Price + CourierFees }}</span
      >
      <span style="font-size: 1.3rem; color: #83cbac" v-if="orderType == 3"
        >￥{{ ordp.Ord_Price + CourierFees }}</span
      >
    </div>
    <div style="text-align: right; margin-top: 0.5rem">
      <el-button @click="SubmitOrders" type="success"> 提交订单</el-button>
    </div>
    <!-- 对话框 -->
    <div>
      <is-show :content="content" :ishow="isShow" />
    </div>
    <!-- 添加和修改地址 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <div style="padding: 0.3rem">
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">收件人:</div>
          <div style="flex: 3">
            <el-input v-model.trim="params.name" />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">联系电话:</div>
          <div style="flex: 3">
            <el-input v-model.trim="params.phone" />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">添加地址:</div>
          <div
            v-if="AddressChange"
            style="flex: 3; display: flex; align-items: center"
          >
            <div
              @click="AddressChange = false"
              style="border: 1px solid #ddd; padding: 10px; border-radius: 5px"
            >
              {{ params.province }}-{{ params.city }}-{{ params.area }}
            </div>
            <span
              style="color: #f00; margin-left: 30px"
              @click="AddressChange = false"
              >编辑</span
            >
          </div>
          <div v-else style="flex: 3">
            <area-cascader
              separator
              type="all"
              :level="1"
              v-model.trim="selected"
              :data="pca"
            />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">地址详情:</div>
          <div style="flex: 3">
            <el-input
              type="textarea"
              resize="none"
              :rows="3"
              placeholder="请输入内容"
              v-model.trim="params.detail"
            />
          </div>
        </div>
        <div class="box-flex">
          <div style="color: #666; margin: 0 0.3rem; flex: 0.7">是否默认</div>
          <div style="flex: 3">
            <el-switch
              v-model.trim="params.isDefault"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addressAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { pca, pcaa } from "area-data";
import { address } from "../../api/http/address";
import { getOrderApi } from "../../api/http/order";
import isShow from "../../components/isPrompt/index.vue";
export default {
  components: {
    isShow,
  },
  data() {
    return {
      orderType: 0,
      person: {
        EContact: "",
        EContact_Email: "",
        EContact_Phone: "",
      }, //工程联系人
      orderNumber: "------", //订单号'
      btnIsShow: true, //点击上传按钮显示隐藏
      orderFromArray: [], //板材信息数组
      indexCoose: 0, //选择
      AddressChange: true,
      content: "", //对话框类容
      isShow: false, //对话框显示
      pca,
      title: "添加地址", //添加地址
      value: true, //是否地址默认
      dialogVisible: false, //地址对话框显示和隐藏
      selected: [], //地址绑定
      CourierChoose: "1", //快递方式
      CourierArray: [
        { label: "1", value: "联昊通速运" },
        { label: "2", value: "速尔速运" },
        { label: "3", value: "顺丰速运" },
        { label: "4", value: "安能速运" },
      ], //快递数组
      params: {
        name: "",
        phone: "",
        province: "",
        city: "",
        area: "",
        detail: "",
        isDefault: true,
      }, //添加
      fileName: "", //上传文件名
      orderFileUrl: "", //订单文件路径
      chooseAddress: "", //选择地址热默认
      addres: [], //默认地址
      addressArray: [], //地址
      PackUp: true, //判断等多地址显示
      or: true, //判断是否是地址
      CourierFees: 0, //快递费
      supplier: [
        {
          label: "国纪",
          value: 1,
        },
        {
          label: "生益",
          value: 2,
        },
        {
          label: "建滔",
          value: 3,
        },
        {
          label: "无要求",
          value: 4,
        },
      ],
      thicknessLList: [
        {
          label: "0.4",
          value: 1,
        },
        {
          label: "0.6",
          value: 2,
        },
        {
          label: "0.8",
          value: 3,
        },
        {
          label: "1",
          value: 4,
        },
        {
          label: "1.2",
          value: 5,
        },
        {
          label: "1.6",
          value: 6,
        },
        {
          label: "2",
          value: 7,
        },
      ],
      layersList: [
        {
          label: 1,
          value: 1,
        },
        {
          label: 2,
          value: 2,
        },
        {
          label: 4,
          value: 3,
        },
      ],
      copperList: [
        {
          label: "1oz",
          value: "1",
          ht: "1",
        },
        {
          label: "1.5oz",
          value: "2",
          ht: "1.5",
        },
        {
          label: "2oz",
          value: "3",
          ht: "2",
        },
      ],
      innerList: [
        {
          label: "1oz",
          value: 1,
          ht: 1,
        },
        {
          label: "1.5oz",
          value: 2,
          ht: 1.5,
        },
        {
          label: "2oz",
          value: 3,
          ht: 2,
        },
      ],
      colorList: [
        {
          label: "绿色",
          value: 1,
        },
        {
          label: "蓝色",
          value: 2,
        },
        {
          label: "黄色",
          value: 3,
        },
        {
          label: "白色",
          value: 4,
        },
        {
          label: "黑色",
          value: 5,
        },
        {
          label: "红色",
          value: 6,
        },
        {
          label: "哑黑色",
          value: 7,
        },
        {
          label: "哑光绿",
          value: 8,
        },
      ],
      testList: [
        {
          label: "目测",
          value: 2,
        },
        {
          label: "电测",
          value: 1,
        },
        {
          label: "飞针",
          value: 3,
        },
      ],
      surfaceList: [
        {
          label: "有铅喷锡",
          value: 1,
        },
        {
          label: "无铅喷锡",
          value: 2,
        },
        {
          label: "OSP",
          value: 3,
        },
        {
          label: "沉金1U",
          value: 4,
        },
        {
          label: "沉金2U",
          value: 5,
        },
      ],
      testFeeList: [
        {
          label: "500",
          value: 1,
        },
        {
          label: "1000",
          value: 2,
        },
      ],
      receiptList: [
        { label: "2", value: "电子收据/送货单" },
        { label: "1", value: "纸质收据/送货单(样板订单收费0.5/元)" },
      ],
      lineWidthList: [
        {
          label: "4/5mil",
          ht: "4/5",
          value: 1,
        },
        {
          label: "5/5mil",
          ht: "5/5",
          value: 2,
        },
        {
          label: "6/6mil",
          ht: "6/6",
          value: 3,
        },
        {
          label: "7/7mil",
          ht: "7/7",
          value: 4,
        },
        {
          label: "8/8mil",
          ht: "8/8",
          value: 5,
        },
        {
          label: "10/10mil",
          ht: "10/10",
          value: 6,
        },
      ],
      formingList: [
        {
          label: "铣边",
          value: 1,
        },
        {
          label: "模冲",
          value: 2,
        },
      ],
      mould1List: [
        {
          label: "公用模具",
          value: 1,
        },
        {
          label: "新开模具",
          value: 2,
        },
      ],
      mouldList: [
        {
          label: "公共测试架",
          value: 1,
        },
        {
          label: "新开测试架",
          value: 2,
        },
      ],
      characterList: [
        {
          label: "黑色",
          value: 1,
          off: false,
        },
        {
          label: "白色",
          value: 2,
          off: false,
        },
        {
          label: "无颜色",
          value: 3,
          off: false,
        },
      ],
      coverList: [
        {
          label: "过孔盖油",
          value: 1,
        },
        {
          label: "过孔开窗",
          value: 2,
        },
        {
          label: "按Gerber文件",
          value: 3,
        },
      ],
      draftList: [
        {
          label: "需要",
          value: 1,
        },
        {
          label: "不需要",
          value: 2,
        },
      ],
      apertureList: [
        {
          label: "0.25mm",
          ht: 0.25,
          value: 1,
        },
        {
          label: "0.3mm",
          ht: 0.3,
          value: 2,
        },
        {
          label: "0.35mm",
          ht: 0.35,
          value: 3,
        },
        {
          label: "0.4mm",
          ht: 0.4,
          value: 4,
        },
        {
          label: "0.5mm",
          ht: 0.5,
          value: 5,
        },
        {
          label: "0.6mm",
          ht: 0.6,
          value: 6,
        },
        {
          label: "0.7mm",
          ht: 0.7,
          value: 7,
        },
        {
          label: "0.8mm",
          ht: 0.8,
          value: 8,
        },
      ],
      factoryList: [
        {
          label: "飞天厂编",
          value: 1,
        },
        {
          label: "FTPCB标志",
          value: 2,
        },
        {
          label: "UL标记",
          value: 3,
        },
        {
          label: "RoHS标记",
          value: 4,
        },
        {
          label: "丝印周期",
          value: 5,
        },
      ],
      puzzleList: [
        { label: "1", value: "单拼" },
        { label: "2", value: "云上初阳代拼" },
        { label: "3", value: "客户自拼" },
      ],
      receiptList: [
        { label: "2", value: "电子收据/送货单" },
        { label: "1", value: "纸质收据/送货单(样板订单收费0.5/元)" },
      ],
      ordp: "", //返单价格
      orderValue: 0, //订单数量
    };
  },
  computed: {
    // 数量计算属性
    getnumberOf() {
      let number = 0;
      if (this.orderType == 2) {
        if (this.orderFromArray[0].det_Num != "") {
          return (number = this.orderFromArray[0].det_Num);
        }
      } else if (this.orderType == 3) {
        return (number = this.orderValue);
      }
      return (number = 0);
    },
  },
  watch: {
    selected(e) {
      for (let index = 0; index < e.length; index++) {
        for (const key in e[index]) {
          if (index == 0) {
            this.params.province = e[index][key];
          } else if (index == 1) {
            this.params.city = e[index][key];
          } else {
            this.params.area = e[index][key];
          }
        }
      }
    },
  },
  // 页面加载生命周期
  created() {
    this.orderType = this.$route.query.id;
    if (this.$route.query.id == 2) {
      this.orderFromArray.push(this.$route.query.orderFrom);
      this.orderFromArray.push(this.$route.query.offerFrom);
      this.orderFromArray.push(this.$route.query.Denominated);
    } else if (this.$route.query.id == 3) {
      console.log(this.$route.query.orderFrom);
      this.orderFrom = this.$route.query.orderFrom;
      this.ordp = this.$route.query.orderOrd;
      this.orderValue = this.$route.query.orderValue;
    }
    this.address();
    //this.addressDefault();
    this.calculate();
    this.getEcotact(); //获取工程联系人
  },
  methods: {
    // 定制选项
    coohse(el, arrayObj) {
      for (let i = 0; i < arrayObj.length; i++) {
        if ((el = arrayObj[i].label)) {
          return arrayObj[i];
        } else {
          return "";
        }
      }
    },
    array(el, array) {
      let arrayList = [];
      for (let i = 0; i < array.length; i++) {
        if (el[i] == array[i].label) {
          arrayList.push(array[i].value);
        }
      }
      return arrayList;
    },
    copper(el, copperArray) {
      for (let i = 0; i < copperArray.length; i++) {
        if (el == copperArray[i].ht) {
          return copperArray[i];
        } else {
          return "";
        }
      }
    },
    // 提交订单
    SubmitOrders() {
      let totalAmount = "";
      let josn = "";
      let quantity = 0;
      let content = "";

      let goodsInfos = "";
      let params = "";
      if (this.orderType == 2) {
        totalAmount = this.orderFromArray[2].Ord_Price + this.CourierFees;
        josn = {
          Det_BoardSize_W: parseFloat(this.orderFromArray[0].det_BoardSize_W),
          Det_BoardSiez_H: parseFloat(this.orderFromArray[0].det_BoardSize_W),
          Det_Num: parseFloat(this.orderFromArray[0].det_Num),
          Det_BoardType: this.orderFromArray[0].Det_BoardType,
          plateType: parseInt(this.orderFromArray[1].PuzzleMode),
          Det_BoardSupplier: this.orderFromArray[0].Det_BoardSupplier,
          supplier: this.coohse(
            this.orderFromArray[0].Det_BoardSupplier,
            this.supplier
          ).value,
          Det_Layer: parseInt(this.orderFromArray[0].Det_Layer),
          layers: this.coohse(this.orderFromArray[0].Det_Layer, this.layersList)
            .value,
          Det_BoardThickness: this.orderFromArray[0].Det_BoardThickness,
          thickness: this.coohse(
            this.orderFromArray[0].Det_Layer,
            this.thicknessLList
          ).value,
          Det_Copper_out: this.orderFromArray[0].Det_Copper_out,
          copper: 1,
          Det_Copper_in:
            this.orderFromArray.Det_BoardType == "高频板"
              ? this.orderFromArray[0].Det_Copper_out
              : this.orderFromArray[0].Det_Copper_in,
          inner: this.coohse(
            this.orderFromArray[0].Det_Copper_in,
            this.innerList
          ).value,
          Det_ZHcolor: this.orderFromArray[0].Det_ZHcolor,
          color: this.coohse(this.orderFromArray[0].Det_ZHcolor, this.colorList)
            .value,
          Det_TestMethod: this.orderFromArray[0].Det_TestMethod,
          test: this.coohse(
            this.orderFromArray[0].Det_TestMethod,
            this.testList
          ).value,
          Det_Surface: this.orderFromArray[0].Det_Surface,
          surface: this.coohse(
            this.orderFromArray[0].Det_Surface,
            this.surfaceList
          ).value,
          Det_TestPrice: parseInt(this.orderFromArray[0].Det_TestPrice),
          testFee: this.coohse(
            this.orderFromArray[0].Det_TestPrice,
            this.testFeeList
          ).value,
          Det_Receipt: parseInt(
            this.coohse(this.orderFromArray[0].Det_Receipt, this.receiptList)
              .label
          ),
          receipt: this.orderFromArray[0].Det_Receipt,
          Det_LineSpacing: this.orderFromArray[0].Det_LineSpacing,
          lineWidth: this.coohse(
            this.orderFromArray[0].Det_LineSpacing,
            this.lineWidthList
          ).value,
          Det_Electroplate: "沉铜",
          electroplate: 0,
          Det_MouldManner: this.orderFromArray[0].Det_MouldManner,
          forming: this.coohse(
            this.orderFromArray[0].Det_MouldManner,
            this.formingList
          ).value,
          special: [],
          Det_IsHalfHole: this.orderFromArray[0].det_IsHalfHole,
          Det_IsImp: this.orderFromArray[0].det_IsImp,
          Det_IsBGA: this.orderFromArray[0].det_IsBGA,
          Det_Isinvoice: this.orderFromArray[0].det_IsHalfHole,
          invoice: parseInt(this.orderFromArray[0].Det_Isinvoice),
          TorderNo: this.orderFromArray[0].TorderNo,
          pcs: "",
          byWidth:
            this.orderFromArray[1].PuzzleMode == 2
              ? thisorderFromArray[1].Process_W
              : "",
          byHeight:
            this.orderFromArray[1].PuzzleMode == 2
              ? thisorderFromArray[1].Process_W
              : "",
          zpX:
            this.orderFromArray[1].PuzzleMode == 3
              ? thisorderFromArray[1].Process_W
              : "",
          zpY:
            this.orderFromArray[1].PuzzleMode == 3
              ? thisorderFromArray[1].Process_W
              : "",
          textModel: this.orderFromArray[0].textModel,
          mould1Xh: this.orderFromArray[0].mould1Xh,
          mould: 0,
          mould1: this.coohse(this.orderFromArray[0].mould1Xh, this.mould1List)
            .value,
          type: 0,
          splicing: this.orderFromArray[1].PuzzleMode,
          character:
            this.coohse(this.orderFromArray[1].ZFcolor, this.characterList)
              .value == ""
              ? 0
              : this.coohse(this.orderFromArray[1].ZFcolor, this.characterList)
                  .value,
          cover:
            this.coohse(this.orderFromArray[1].ViaWay, this.coverList).value ==
            ""
              ? 0
              : this.coohse(this.orderFromArray[1].ZFcolor, this.coverList)
                  .value,

          draft:
            this.coohse(this.orderFromArray[1].draft, this.draftList).value ==
            ""
              ? 0
              : this.coohse(this.orderFromArray[1].draft, this.draftList).value,
          aperture:  this.orderFromArray[1].aperture,
          breakBoard: [0],
          factory: this.copper(
            this.orderFromArray[1].CharacterTagsArray,
            this.factoryList
          ),
          standard: 1,
          Det_Pmodels: parseInt(this.orderFromArray[0].det_Pmodels),
          set: this.orderFromArray[1].set,

          typeText: "样板",
          draftText: "不需要",
          standardText: "IPC-A-600J 2级接受标准",
          factoryText: "飞天厂编",
          apertureText: this.orderFromArray[1].aperture+"mm",
          apertureValue: this.coohse(
            this.orderFromArray[1].aperture,
            this.apertureList
          ).value,
          coverText: this.orderFromArray[1].ViaWay,
          invoiceText:
            this.orderFromArray[0].Det_Isinvoice == "0" ? "不开发票" : "开发票",
          characterText: this.orderFromArray[1].ZFcolor,
          Det_Testingjig: this.orderFromArray[0].Det_Testingjig,
          splicingText: this.coohse(
            this.orderFromArray[1].PuzzleMode,
            this.puzzleList
          ).value,
          receiptText: this.coohse(
            this.orderFromArray[0].Det_Receipt,
            this.receiptList
          ).value,
          Det_mould: this.orderFromArray[0].mould1Xh,
          Area: this.orderFromArray[0].area,
          isBreakBoard: 1,
          version: this.orderFromArray[0].specificModels,
          ruleForm: {
            det_BoardSize_W: parseFloat(this.orderFromArray[0].det_BoardSize_W),
            useratio: 0,
            version: this.orderFromArray[0].specificModels,
            det_Copper_high: 0,
            det_BoardSiez_H: parseFloat(this.orderFromArray[0].det_BoardSiez_H),
            det_Num: parseFloat(this.orderFromArray[0].det_Num),
            det_Pmodels: parseFloat(this.orderFromArray[0].det_Pmodels),
            det_BoardType: this.orderFromArray[0].Det_BoardType,
            det_BoardSupplier: this.orderFromArray[0].Det_BoardSupplier,
            det_Layer: parseInt(this.orderFromArray[0].Det_Layer),
            det_BoardThickness: this.orderFromArray[0].Det_BoardThickness,

            det_Copper_out: this.orderFromArray[0].Det_Copper_out,
            det_Copper_in: this.orderFromArray[0].Det_Copper_in,
            det_ZHcolor: this.orderFromArray[0].Det_ZHcolor,
            det_TestMethod: this.orderFromArray[0].Det_TestMethod,
            det_Surface: this.orderFromArray[0].Det_Surface,
            det_LineSpacing: this.orderFromArray[0].Det_LineSpacing,
            det_MouldManner: this.orderFromArray[0].Det_MouldManner,
            det_IsHalfHole: this.orderFromArray[0].det_IsHalfHole,
            det_IsImp: this.orderFromArray[0].det_IsImp,
            det_IsBGA: this.orderFromArray[0].det_IsBGA,
            det_Isinvoice: parseInt(this.orderFromArray[0].Det_Isinvoice),
            area: this.orderFromArray[0].area,
          },
          Ord_Price: this.orderFromArray[2].Ord_Price,
        };
        console.log(josn);
        quantity = parseInt(this.orderFromArray[0].det_Num);
        content = JSON.stringify(josn);
        goodsInfos = [{ content, quantity }];
        params = {
          orderType: this.orderType,
          ProduceOrderNo: this.orderNumber,
          addressId: this.chooseAddress.Id,
          amount: totalAmount,
          AnnexUrl: this.orderFileUrl,
          goodsInfos,
          eContact: this.person.EContact,
          eContact_Email: this.person.EContact_Email,
          eContact_Phone: this.person.EContact_Phone,
          model: this.fileName,
        };
      } else if (this.orderType == 3) {
        let conten = JSON.parse(this.orderFrom.OrderGoodsDtos[0].Content);
        conten.Det_Num = this.orderValue;
        conten.Area = this.orderValue;
        josn = conten;
        quantity = parseInt(this.orderValue);
        content = JSON.stringify(josn);
        goodsInfos = [{ content, quantity }];
        params = {
          orderType: this.orderType,
          addressId: this.chooseAddress.Id,
          amount: this.ordp.Ord_Price,
          AnnexUrl: conten.other.AnnexUrl,
          goodsInfos,
          eContact: this.person.EContact,
          eContact_Email: this.person.EContact_Email,
          eContact_Phone: this.person.EContact_Phone,
          model: this.orderFrom.Model,
        };
      }

      getOrderApi.setSubmit(params).then((res) => {
        if (res.data.code == 200) {
          this.$router.push({ path: "/memberCenter" });
          this.$message({
            message: "订单提交成功！！",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //获取工程联络人接口
    getEcotact() {
      getOrderApi.getEcotact().then((res) => {
        if (res.data.data != null) {
          return (this.person = res.data.data);
        }
      });
    },
    // 上传成功回调
    succes(response, file, fileList) {
      if (response.length != 0) {
        this.orderFileUrl = response[0];
        this.orderNumber = response[1];
        this.btnIsShow = false;
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 文件移除钩子方法
    handleRemove() {
      this.orderNumber = "-------";
      this.btnIsShow = true;
      this.fileName = "";
    },
    // 文件变化钩子方法
    handleFileChange(file) {
      this.fileName = file.name;
    },

    // 运费计算
    calculate() {
      if (this.orderType == 2) {
        if (this.orderFromArray[0].Det_BoardThickness == undefined) {
          this.$router.push({ path: "/OnlineInvoicing" });
        }
      } else if (this.orderType == 3) {
        if (this.ordp.Ord_Price == undefined) {
          this.$router.go(-1);
        }
      }
    },
    // 点击添加地址
    clickIsShow() {
      console.log("111")
      this.dialogVisible = true;
      this.or = true;
      this.AddressChange = false;
      for (const key in this.params) {
        if (key != "isDefault") {
          this.params[key] = "";
        }
      }
    },
    // 编辑
    editor(e) {
      this.selected = [];
      this.or = false;
      this.dialogVisible = true;
      this.params.name = e.Name;
      this.params.id = e.Id;
      this.params.phone = e.Phone;
      this.params.detail = e.Detail;
      this.params.city = e.City;
      this.params.province = e.Province;
      this.params.area = e.Area;
      this.params.isDefault = e.IsDefault;
    },
    // 选择
    choose(e, item) {
      this.indexCoose = e;
      this.chooseAddress = item;
      this.calculate();
    },
    // 更多地址
    more() {
      this.PackUp = false;
      for (let index = 0; index < this.addressArray.length; index++) {
        this.addres.push(this.addressArray[index]);
      }
    },
    // 默认地址
    // addressDefault() {
    //   let this_ = this;

    //   address.addressDefault().then((res) => {
    //     if (res.data.code == 200) {
    //       this.chooseAddress = res.data.data;

    //       this_.addres.push(res.data.data);
    //     }
    //   });
    // },
    // 地址添加
    addressAdd() {
      let this_ = this;
      let Boolean = false;

      for (const key in this.params) {
        if (key != "isDefault") {
          if (this_.params[key] == "") {
            Boolean = false;
          } else {
            Boolean = true;
          }
        }
      }
      if (Boolean) {
        if (this.or) {
          address.addressAdd(this.params).then((res) => {
            let { code, msg } = res.data;
            if (code == 200) {
              this.$message({
                message: "添加成功！",
                type: "success",
              });
              this_.dialogVisible = false;
              this.address();
            } else {
              this.$message({
                message: "添加失败！",
                type: "error",
              });
              this_.dialogVisible = false;
            }
          });
        } else {
          address.addressAdd(this_.params).then((res) => {
            let { code } = res.data;
            if (code == 200) {
              this_.isShow = true;
              this_.content = "修改成功！！";
              this_.dialogVisible = false;
            } else {
              this_.isShow = true;
              this_.content = "修改失败！！";
              this_.dialogVisible = false;
            }
          });
        }
      }
    },
    // 地址列表
    address() {
      let this_ = this;
      this.addres = [];
      address.addressList({ page: 1, size: 100 }).then((res) => {
        console.log("11111")
        console.log(res)
        if(res.data.data.length!=0){
            this_.addressArray = res.data.data.reverse();
        this.addres.push(this_.addressArray[0]);
        this.chooseAddress = this_.addressArray[0];
        }
      
      });
    },
    // 关闭弹窗
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.sorcll {
  height: 500px;
  overflow-y: scroll;
}
.addresFlex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
// 选择何种
.flexBox {
  display: flex;
  margin-top: 1rem;

  div {
    width: 110px;
    .el-input {
      width: 200px;
    }
  }
}
.box {
  width: 100px;
  border: 1px solid #83cbac;

  padding: 7px;
  border-radius: 5px;
  text-align: center;
  background-image: url(../../assets/imges/checked.png);
  background-repeat: no-repeat;
  background-size: 1.6rem;
  background-origin: border-box;
  box-shadow: none;
  background-position-x: 100%;
  background-position-y: 100%;
}
.chooseNot {
  width: 100px;
  border: 1px solid #999;
  padding: 7px;
  border-radius: 5px;
  text-align: center;
}
// 订单底部信息
.orderBottom {
  margin-top: 1rem;
  text-align: right;
  background: #eee;
  padding: 0.5rem 0;
  div {
    margin-right: 0.8rem;
  }
}
.box-flex {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;

  .el-input {
    width: 10rem;
  }
}
.TheOrder {
  align-items: center;
  margin-top: 1rem;
}
// 订单信息
.orderInformation {
  .from {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 00.1rem solid #999;
    div {
      padding: 5px;
      flex: 1;
      text-align: center;
      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }
  .fromHeader {
    display: flex;
    background: #83cbac;
    height: 2rem;
    font-size: 1rem;
    font-weight: 600;
    color: #fff;
    justify-content: center;
    align-items: center;
    div {
      flex: 1;
      text-align: center;
    }
  }
}
// 页面css
.orderImmediately {
  width: 60vw;
  margin: auto;
  margin-top: 3rem;
  box-sizing: border-box;

  // 带箭头那在css
  .flexCenter {
    flex: 2;
    justify-content: center;
    align-items: center;
    border-radius: 00.3rem;
    color: #fff;
    background-color: #83cbac;
    display: flex;
    div {
      flex: 1;
      text-align: center;
    }
  }
  // 添加css
  .address {
    margin-top: 1rem;
    p {
      font-weight: 900;
      color: #000;
      font-size: 1rem;
    }
  }
  .steps {
    margin-top: 0.5rem;
    background: #83cbac;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    div {
      text-align: center;
      flex: 1;
      padding: 0.2rem 0;
      span {
        position: relative;
        top: -1rem;
      }
    }
  }
  .ExpressWay {
    margin-top: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/my/orderImmediately.vue